import { render, staticRenderFns } from "./InlineAccountTabs.vue?vue&type=template&id=4346f4a8&lang=pug"
import script from "./InlineAccountTabs.vue?vue&type=script&lang=js"
export * from "./InlineAccountTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Login: require('/home/docker/code/frontend/components/Login.vue').default,Register: require('/home/docker/code/frontend/components/Register.vue').default,LinkLogin: require('/home/docker/code/frontend/components/LinkLogin.vue').default,ForgotPassword: require('/home/docker/code/frontend/components/ForgotPassword.vue').default})
